import { RootState } from '@/store';

export const newEgrnOrderSelector = (state: RootState) => {
  return state.egrnStore.newOrder;
};
export const pageOrderSelector = (state: RootState) => {
  return state.egrnStore.ordersPage;
};
